import { HourglassFilled } from '@ant-design/icons';
import { Tag } from 'antd';
import styles from 'styles/components/slowResponderBadge.module.scss';

const SlowResponderBadge = ({ style = {} }) => (
  <Tag className={styles.slowResponder} style={style}>
    <HourglassFilled style={{ marginRight: 4, fontSize: 12 }} />
    SLOW RESPONDER
  </Tag>
);

export default SlowResponderBadge;
